import React from 'react';
import { DialogV2 } from '@withjoy/joykit';
import { StyledPhoto, StyledTitle, StyledPrice, StyledStack, StyledButton } from './PreviewAndEditCatalogCashItemDialog.styles';
import { useCatalogRegistryTranslations } from '../../Catalog.i18n';
import { addRendition } from '@shared/utils/photoRendition';
import type { CatalogItemTile } from '../../Catalog.types';
import type { CashFundDialogContext } from '../CashFundDialogProvider';
import { useCurrencyFormatter } from '@shared/utils/currency';

export interface PreviewAndEditCatalogCashItemDialogProps
  extends Readonly<{
    isOpen: boolean;
    onClose: () => void;
    product: CatalogItemTile;
    editCurrentProduct: CashFundDialogContext['openAddCatalogCashFundDialog'];
    itemPosition: Maybe<number>;
  }> {}

export const PreviewAndEditCatalogCashItemDialog: React.FC<PreviewAndEditCatalogCashItemDialogProps> = props => {
  const { itemPosition, product, onClose, isOpen, editCurrentProduct } = props;
  const { getCashFundCatalogTranslations } = useCatalogRegistryTranslations();
  const { editAndAdd } = getCashFundCatalogTranslations();
  const { formatCurrency } = useCurrencyFormatter();

  const formattedProductPrice = formatCurrency({
    priceFloatingPointDecimalString: product.price?.floatingPointDecimalString ?? '0',
    priceCurrencyCode: product.price?.currency?.code,
    formatForm: 'short',
  });
  const photoUrl = addRendition({ url: product.photos[0]?.url, renditionSize: 'large' });

  const onEditAndAdd = () => {
    if (product) {
      editCurrentProduct({ addMethodType: 'pdp modal cta', product, itemPosition });
    }
  };

  return (
    <DialogV2
      isOpen={isOpen}
      size="xl"
      onClose={onClose}
      overrides={{
        CloseButton: {
          props: {
            height: 44,
            width: 44,
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            top: 5,
            right: 5,
          },
        },
      }}
    >
      <StyledPhoto photoUrl={photoUrl}>
        <DialogV2.CloseButton />
      </StyledPhoto>
      <StyledStack
        spacing={7}
        marginBottom={7}
      >
        <StyledStack spacing={3}>
          <StyledTitle fontSize={24}>{product.title}</StyledTitle>
          <StyledPrice>{formattedProductPrice}</StyledPrice>
        </StyledStack>
        <StyledButton onClick={onEditAndAdd}>{editAndAdd}</StyledButton>
      </StyledStack>
    </DialogV2>
  );
};
